
import { useState } from 'react';
import Button from '../base/Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Blog', href: '/blog' },
    { name: 'Service Areas', href: '/service-areas' },
    { name: 'Contact', href: '/contact' }
  ];

  const tools = [
    { name: 'AI Assessment', href: '/tools/ai-assessment' },
    { name: 'ROI Calculator', href: '/tools/roi-calculator' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-robot-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-semibold text-gray-900" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ebusiness Marketing Group
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
              Home
            </a>
            <a href="/services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
              Services
            </a>
            <a href="/about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
              About
            </a>
            <a href="/portfolio" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
              Portfolio
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button href="/contact" variant="primary" className="whitespace-nowrap">
              Get Started
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
                Home
              </a>
              <a href="/services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
                Services
              </a>
              <a href="/about" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
                About
              </a>
              <a href="/portfolio" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">
                Portfolio
              </a>
              <Button href="/contact" variant="primary" className="w-full whitespace-nowrap">
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
